import { useBottomPanel } from '@ubnt/link-core-ui/components/BottomPanel/context/BottomPanelContext';
import { DeviceVariantsEnum } from '@ubnt/link-core/enums';
import isEqual from 'fast-deep-equal';
import { useCallback } from 'react';

import { isEnumValue } from '@ubnt/wifi-calculator/utils/isEnumValue';
import { resolveVariant } from '@ubnt/wifi-calculator/utils/resolveVariant';
import { useDispatch, useSelector } from 'app/store';
import {
  devicesDeviceInstanceSelector,
  devicesDeviceUpdate,
  devicesDeviceVariantSelector,
} from 'modules/devices/slice';
import { linksDeviceRadioLabelSelector, linksDeviceVariantOptionsSelector } from 'modules/links/slice';

import { trackEvent } from 'utils/googleAnalytics';
import TabsPicker, { TabsPickerProps } from '../components/elements/TabsPicker';

const RadioPicker = (props: Partial<TabsPickerProps>) => {
  const { leftId: id, linkId } = useBottomPanel();

  const label = useSelector((state) => id && linksDeviceRadioLabelSelector(state, id));

  const options = useSelector((state) => linkId && linksDeviceVariantOptionsSelector(state, linkId), isEqual);
  const deviceInstance = useSelector((state) => id && devicesDeviceInstanceSelector(state, id));
  const variant = useSelector((state) => (id ? devicesDeviceVariantSelector(state, id) : undefined));
  const value = deviceInstance && variant != null ? resolveVariant(deviceInstance.variants, variant) : undefined;
  const dispatch = useDispatch();

  const onChange = useCallback(
    (newVariantString: string) => {
      const newVariant = Number(newVariantString);
      if (id && isEnumValue(DeviceVariantsEnum, newVariant)) {
        dispatch(devicesDeviceUpdate({ id, changes: { variant: newVariant } }));
        trackEvent('bottomPanelRadioChange', { variant: newVariant });
      }
    },
    [dispatch, id]
  );

  if (!id || !options) {
    return null;
  }

  return (
    <TabsPicker
      label={label ?? 'WiFi'}
      onChange={onChange}
      options={options}
      testId="radio-picker"
      value={value == null ? null : value.toString()}
      {...props}
    />
  );
};

export default RadioPicker;
